import React from "react";

const Loader = ({ loading }) => {
  return (
    <React.Fragment>
      <div
        className="overlay_spinner"
        style={{
          display: loading ? "flex" : "none",
          marginTop: loading && "-100px",
        }}
      >
        <div className="overlay__inner">
          <div className="overlay__content">
            <span className="spinner"></span>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Loader;
